/**
 * User/Creator service
 */
import api from './api';

export const userService = {
  /**
   * Get all creators
   */
  async getCreators() {
    console.log('[UserService] Fetching creators...');
    try {
      const response = await api.get('/api/creators');
      console.log('[UserService] Creators response:', response.data);
      console.log('[UserService] Number of creators:', response.data.length);
      return response.data;
    } catch (error) {
      console.error('[UserService] Error fetching creators:', error);
      console.error('[UserService] Error response:', error.response?.data);
      throw error;
    }
  },

  /**
   * Get creator by ID
   */
  async getCreator(creatorId) {
    const response = await api.get(`/api/creators/${creatorId}`);
    return response.data;
  },

  /**
   * Get user profile (alias for getCreator for backward compatibility)
   */
  async getUserProfile(userId) {
    return this.getCreator(userId);
  },

  /**
   * Get my subscribers
   */
  async getMySubscribers() {
    const response = await api.get('/api/subscriptions/subscribers');
    // Backend returns { subscribers: [...], total_count: N, monthly_revenue: X }
    // Return just the subscribers array for backward compatibility
    return response.data.subscribers || [];
  },

  /**
   * Update profile
   */
  async updateProfile(profileData) {
    const response = await api.put('/api/auth/me', profileData);
    return response.data;
  }
};
